import { TabFileError } from './errors';
/** Every e-file status TabFile can report, in the order the UI lists them. */
export const FILING_STATUSES = [
    'queued',
    'transmitting',
    'processing',
    'accepted',
    'accepted_with_errors',
    'partially_accepted',
    'rejected',
    'failed',
];
/** Statuses that mean the e-file is still moving, so the UI keeps refreshing. */
export const IN_FLIGHT_FILING_STATUSES = ['queued', 'transmitting', 'processing'];
export function isInFlight(status) {
    return IN_FLIGHT_FILING_STATUSES.includes(status);
}
/**
 * Whether a correction or a replacement may be filed against this e-file right now.
 *
 * Read from `actions`, never worked out from the status: the server has to weigh the IRS
 * status, whether anything is still in flight, whether it has already been replaced and
 * whether the grace window is still open, and a second implementation of that in a UI is a
 * second implementation that can disagree.
 */
export function canCorrect(filing) {
    return (filing.actions ?? []).includes('correct');
}
export function canReplace(filing) {
    return (filing.actions ?? []).includes('replace');
}
/** Every upload format TabFile accepts, in the order the UI offers them. */
export const UPLOAD_FORMATS = ['csv', 'xlsx', 'pub1220', 'irisxml'];
/** csv and xlsx carry one row per return, so the caller must say which form it is. */
export function needsFormAndYear(format) {
    return format === 'csv' || format === 'xlsx';
}
/**
 * POST /v1/e-files answers 422 with a CheckResult rather than a problem document.
 * This pulls that result back out of the thrown error.
 */
export function checkResultFromError(error) {
    if (!(error instanceof TabFileError) || error.status !== 422)
        return undefined;
    const body = error.body;
    if (!body || typeof body.ok !== 'boolean' || !Array.isArray(body.issues))
        return undefined;
    return body;
}
//# sourceMappingURL=types.js.map